export default function memoRequest<
  T extends (...args: any) => Promise<any>
>(request: T): T {
  let value: Promise<any> | undefined
  return function (...args: any) {
    if (value === void 0) {
      value = request(...args)
    }
    return value
  } as T
}
